import { MetodoCargaDescarga } from "./cargadescarga";

/**
 * Los status posibles de la guia, todos estos valores estan en función de los Ids del @see StatusGuiaView  por lo que no proporciona información adicional al status de la guia,
 * son exclusivamente para ser mostrados al usuario. No utilice estos status para tomar decisiones
 */
/**Los status posibles de la guia */
export enum StatusGuia {
    /**
     * Este status nunca debe de ocurrir, se da cuando las condiciones de la guia hacen que no encaje en ninguno de los status validos.
     * Por ejemplo que este en viaje y en sucursal seria un status invalido
     */
    Invalido = -1,

    /**Es true si es una guia de recolección a domicilio que aun no ha sido recolectada */
    RecoleccionPendiente = 0,

    /**True si la guia está en el almacen de la sucursal destino */
    EnSucursalDestino = 1,

    /**True si la guia esta en la sucursal de origen */
    EnSucursalOrigen = 2,

    /**True si la guia esta en una sucursal que no es la de destino ni la de origen */
    EnSucursalTrasbordo = 3,

    /**True si la guia ya fue entregada a ocurre */
    EntregadaOcurre = 4,

    /**True si la guia se encuentra en viaje de ruta */
    EnViaje = 5,

    /**True si la guia se encuentra en una caja de ruta y no esta en viaje */
    EnEmbarque = 6,

    /**True si la guia se encuentra en viaje de entrega a domicilio */
    EnViajeEAD = 7,

    /**Si se encuentra arriba de un camión de EAD pero aun no esta en viaje */
    EnCamionEAD = 8,

    /**La guia fue entregada exitosamente en una entrega a domicilio */
    EntregadaDomicilio = 9,

    /**La guia se encuentra en medio de un viaje de EAD en el cual fue rechazada por el cliente destino */
    EnViajeEADRechazada = 10,

    /**La guia se encuentra en medio de un viaje de EAD en el cual la guia no fue entergada  */
    EnViajeEADIncompleta = 11,

    /**
     * Indica que la guia fue creada con la marca de @see ContenidoPendiente  y aún no ha llegado el contenido de la guia, es exactamente igual que el status @see StatusGuia.RecoleccionPendiente  
     */
    ContenidoPendiente = 12,

    /**Indica que la guía fue cancelada */
    Cancelada = 13,

    /**Indica que la guía está en un viaje de ZE */
    EnViajeZE = 14,

    /**Indica que la guía está en un vehículo de zona extendida */
    EnVehiculoZE = 15,

    /**indica que la guía fue entregada en zona extendida */
    EntregadaZonaExtendida = 16,

    /**Indica que la guía fue rechazada en Zona extendida */
    EnViajeZERechazada = 17,

    /**Indica que la guía fue incluida en una entrega incompleta de zona extendida */
    EnViajeZEIncompleta = 18
}


/**
 * Descripcion de un registro de la tabla StatusGuiaView, cuando este registro implique una:
 * 1.- Entrega a domicilio
 * 2.- Rechazo de la guia en entrega a domicilio
 * 3.- Guia en una entrega no realizada
 * Tendrá un valor asignado. Si no, sera null
 */
export enum TipoEntregaDomicilio {
    /**La guia fue entregada exitosamente */
    Entregada = 0,
    /**La guia fue rechazada explicitamente por el cliente destino en el momento de la entrega */
    RechazadaPorClienteDestino = 1,

    /**No se pudo realizar la entrega al cliente, por ejemplo cuando el cliente destino no fue encontrado */
    EntregaIncompleta = 2,
}

/**
 * Descripcion de un registro de la tabla StatusGuiaView, cuando este registro implique una:
 * 1.- Entrega a ze
 * 2.- Rechazo de la guia en ZE
 * 3.- Guia en una entrega no realizada
 * /// Tendrá un valor asignado. Si no, sera null
 */
export enum TipoEntregaZE {
    /**La guia fue entregada exitosamente */
    Entregada = 0,
    /**La guia fue rechazada explicitamente por el cliente destino en el momento de la entrega */
    RechazadaPorClienteDestino = 1,

    /**No se pudo realizar la entrega al cliente, por ejemplo cuando el cliente destino no fue encontrado */
    EntregaIncompleta = 2,
}

/**Indica el proceso que origino cierto registro del status de la guia */
export enum OrigenStatusGuia {
    StatusInicial = 1,
    EntregaOcurre = 2,
    AsigadoASucursal = 3,
    CargaDescargaCajaRuta = 4,
    ViajeRuta = 5,
    CargaDescargaEAD = 6,
    ViajeEAD = 7,
    EntregaDomicilioGuiaAceptada = 8,
    EntregaDomicilioGuaRechazada = 9,
    EntregaDomicilioEntregaIncompleta = 10,
    RecoleccionDomicilio = 11,
    LlegoContenido = 12,
    RecoleccionPorManifiesto = 13,
    Cancelacion = 14,
    VehiculoZE = 15,
    ViajeZE = 16,
    EntregaZEGuiaAceptada = 17,
    EntregaZEGuiaRechazada = 18,
    EntregaZEEntregaIncompleta = 19
}

/**VIEW de los status de la vista. Este view se alimenta de todas las tablas que generan cambios de status a la guia y sirve para consultar la ubicación y el status de cada guia */
export interface StatusGuiaView {
    /**Guia */
    IdGuia: number;

    /**Fecha del movimiento */
    Fecha: Date | string;

    /**
     * Sucursal en la que se encuentra la guia DESPUES de este evento. El hecho de que la sucursal se considere despues del evento implica que las entregas no van a tener sucursal asignada, ademas de que cuando la guia se encuentre en tránsito
     * tampoco va a tener asignada la sucursal en este campo
     */
    IdSucursal: number | null;

    /**En caso de que la caja de la guia este conectada a un camion en un viaje, este indica el viaje de la guia  */
    IdViajeRuta: number | null;

    /**En caso de que la guia se encuente arriba de una caja, esta es la caja en la que se encuentra */
    IdCajaRuta: number | null;

    /**En caso de que la guia se encuentre en una caja y esta este asignada a un camion, es el camion de la guia */
    IdCamion: number | null;

    /**En caso de que la guia se encuentre en un vehículo de zona extendida, es el vehículo de ZE donde se encuentra la guia */
    IdVehiculoZE: number | null;

    /**En caso de que la guia se encuentre en un viaje de zona extendida, es el viaje de ZE donde se encuentra la guia */
    IdViajeZE: number | null;

    /**
     * Id del @see ContactoCliente  que recibió la guia, este valor solo va a estar asignado si la guia ya fue entregada, es decir si su estatus de EntregadaOcurre o EntregadaDomicilio
     */
    IdContactoClienteRecibio: number | null;

    /**Status de la guia */
    Status: StatusGuia;

    /**Tipo de la entrega a domicilio en caso de que esta fila represente un evento de entrega realizada, entrega incompleta o guia rechazada por cliente destino */
    TipoEntregaDomicilio: TipoEntregaDomicilio | null;

    /**Tipo de la entrega ZE en caso de que esta fila represente un evento entregada realizada, entrega incompleta o guia rechazada por cliente destino */
    TipoEntregaZE: TipoEntregaZE | null;

    /**Indica el proceso que origino esta fila en el status de la guia */
    OrigenStatus: OrigenStatusGuia;


    /**Id del usuario relacionado con este status */
    IdUsuario: number | null;

    /**Metodo de escaneo en caso de que sea un movimiento de carga/descarga */
    MetodoEscaneo: MetodoCargaDescarga | null;
}

export interface StatusGuiaViewDTO extends StatusGuiaView {
    NombreSucursal: string;
    NombreContactoClienteRecibio: string;
    NombreViajeRuta: string;
    NombreCaja: string;
    NombreCamion: string;
    FolioViajeEAD: number;
    NombreVehiculoZE: string;
    FolioViajeZE: number | null;
    NombreRutaViajeRuta: string;
    DescripcionRutaViajeRuta: string;
    NombreViajeOrigen: string;
    NombreViajeDestino: string;
    NombreCamionEAD: string;
    NombreUsuario: string;
}


// WEBPACK FOOTER //
// ./app/models/status.ts